// ABOUTME: Save button for settings screens whose fields defer persisting to one explicit action.
// ABOUTME: Sits in the screen header and stays reachable on a phone, where the heading is hidden.

import { useTheme } from '@mui/material';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import { useTranslation } from "react-i18next";
import Shbutton from '../../theme/buttons/Shbutton';

const SettingsSaveButton = ({ onClick, isLoading = false, disabled = false }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Shbutton
      color={theme.palette.mode === "dark" ? "blue" : "primary"}
      variant="contained"
      onClick={onClick}
      isLoading={isLoading}
      disabled={disabled}
      endIcon={<SaveOutlinedIcon />}
      sx={{
        flexShrink: 0,
        marginLeft: "auto",
      }}
    >
      {t('save')}
    </Shbutton>
  );
};

export default SettingsSaveButton;
